import React, { useEffect, useRef, useState } from "react";
import { Loader } from "../global/loader";
import add from "../../images/add.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";

export const Ticketdetail = ({ checkMessageNotification }) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [msgInput, setMsgInput] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [messageId, setMessageId] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const chatRef = useRef(null);

  const getTickets = async () => {
    try {
      setLoader(true);
      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getTicket(params?.id);
      // console.log(response);
      if (response?.success) {
        setData(response?.ticket);
        checkMessageNotification();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (params?.id) {
      getTickets();
    }
  }, []);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const addMessage = async () => {
    try {
      setLoader(true);
      let payload = {
        id: data.issueId,
        sender: "user",
        message: msgInput,
      };
      // console.log(payload);
      const response = await api.addTicketChat(payload);
      console.log(response);
      if (response?.success) {
        setMsgInput("");
        setData(response?.ticket);
      }
      setLoader(false);
    } catch (error) {
      console.log(error.message);

      alert.show(error.message || "Something went wrong.");
      setLoader(false);
    }
  };
  const formatDateMessage = (date) => {
    let dateTemp = moment(date).format("MMMM Do YY, h:mm a");
    return dateTemp;
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      getTickets();
    }, 20000); // 30,000 ms = 30 seconds

    // Cleanup on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const editMessage = async () => {
    try {
      setLoader(true);
      let payload = {
        issueId: data.issueId,
        messageId: messageId,
        newMessage: newMessage,
      };
      // console.log(payload);
      const response = await api.editTicketChat(payload);
      // console.log(response);
      if (response?.success) {
        setEditModal(false);
        setMessageId("");
        setNewMessage("");
        getTickets();
        alert.show(response?.message);
      } else {
        alert.show(response?.error || "Something went wrong.");
      }
      setLoader(false);
    } catch (err) {
      alert.show(err.message || "Something went wrong.");
      setLoader(false);
    }
  };

  const handleEditModal = (id, message) => {
    setMessageId(id);
    setNewMessage(message);
    setEditModal(true);
  };

  const scrollToBottom = () => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [data?.messages]);

  return (
    <div className="createTicketPage">
      <div className="contact-widget-area ">
        <div className="contact-widget-area-inner">
          <h2 className="section-title text-center mb-45 just-sans-bold">
            Ticket Detail
          </h2>
          <div className="row">
            <div className="col-md-6">
              <div className="issueDetail">
                <div className="mb-3">
                  <div className="value">Issue ID</div>
                  <div className="title">{data?.issueId}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue type</div>
                  <div className="title">{data?.issueType}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue Status</div>
                  <div className="title text-capitalized">{data?.status}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue Description</div>
                  <div className="title">{data?.description}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue Created At</div>
                  <div className="title">{formatDate(data?.createdAt)}</div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="chatMain">
                {editModal && (
                  <EditModalComp
                    newMessage={newMessage}
                    editMessage={editMessage}
                    setNewMessage={setNewMessage}
                    setEditModal={setEditModal}
                  />
                )}
                <div className="chatTitle">Chat</div>
                {data?.status == "processing" && (
                  <div className="alert alert-warning py-2" role="alert">
                    Note: This ticket will be closed if you do not respond
                    within 48 hours.
                  </div>
                )}
                {data?.status == "processing" ? (
                  <>
                    <div className="chatMainCol" ref={chatRef}>
                      {data?.messages?.map((val, key) => (
                        <div
                          className={
                            val?.sender == "user" ? "receiver" : "sender"
                          }
                          key={key}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: val?.message,
                            }}
                          />
                          <div className="time">
                            {formatDateMessage(val?.timestamp)}
                          </div>
                          {val?.sender == "admin" && (
                            <>
                              <div className="name">{val?.senderId?.name}</div>
                            </>
                          )}
                          {val?.sender == "user" && (
                            <>
                              {val?.senderId?._id ===
                                userStore?.users?.user?._id &&
                                new Date() - new Date(val?.timestamp) <=
                                  5 * 60 * 1000 && (
                                  <div className="dropD dropdown">
                                    <i
                                      className="fa-solid fa-ellipsis-vertical"
                                      id="dropdownMenuButton1"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    ></i>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleEditModal(
                                              val?._id,
                                              val?.message
                                            )
                                          }
                                        >
                                          Edit
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                            </>
                          )}
                        </div>
                      ))}
                      {/* <div className="sender">test</div> */}
                    </div>
                    <div className="senMsg">
                      <textarea
                        rows={1}
                        placeholder="Type here..."
                        value={msgInput}
                        onChange={(e) => setMsgInput(e.target.value)}
                      ></textarea>
                      <button
                        disabled={msgInput ? false : true}
                        onClick={addMessage}
                        className="button"
                      >
                        <i className="fa-solid fa-paper-plane"></i>
                      </button>
                    </div>
                  </>
                ) : (
                  <h6 className="text-center">
                    {data?.status == "closed"
                      ? "Your issue has been solved successfully. Thank you for contacting Team WZ support."
                      : "Chat will be available when admin process your ticket."}
                  </h6>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
};

const EditModalComp = ({
  editMessage,
  newMessage,
  setNewMessage,
  setEditModal,
}) => {
  return (
    <>
      <div className="editModal">
        <div className="closeModal" onClick={() => setEditModal(false)}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="senMsg">
          <textarea
            rows={1}
            placeholder="Type here..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
          ></textarea>
          <button
            className="button"
            disabled={newMessage ? false : true}
            onClick={editMessage}
          >
            <i className="fa-solid fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </>
  );
};
